module.exports = __webpack_public_path__ + "static/media/lia.fd9b7600.png";